import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  Input,
  OnDestroy,
} from "@angular/core";
import {
  ControlValueAccessor,
  FormArray,
  FormBuilder,
  FormControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  Validators,
} from "@angular/forms";
import { NgbDateParserFormatter } from "@ng-bootstrap/ng-bootstrap";
import { PlacementArray } from "@ng-bootstrap/ng-bootstrap/util/positioning";
import { NgbCustomParserFormatter } from "components/common/date-picker/ngb-custom-parser-formatter";
import { ResourceManagementService } from "../../../../providers/resource-management/resource-management.service";
import { ContactDetails } from "../contact-details";

@Component({
  selector: "employee-health-contact-details",
  templateUrl: "employee-health-contact-details.html",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EmployeeHealthContactDetails),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => EmployeeHealthContactDetails),
      multi: true,
    },
    { provide: NgbDateParserFormatter, useClass: NgbCustomParserFormatter },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmployeeHealthContactDetails
  extends ContactDetails
  implements ControlValueAccessor, OnDestroy
{
  datePlacementPreference: PlacementArray = ["bottom-left"];
  givenMin: any = "";
  givenMax: any = "";
  readMin: any = "";
  readMax: any = "";
  nextRequiredMin: any = "";
  nextRequiredMax: any = "";
  allVaccinationOptions = [];
  vaccinationOptions = [];

  vaccine = ["COVID_19", "FLU", "HEPATITIS_B", "TB"];

  @Input() isEditMode: boolean = false;

  get vaccinations() {
    return this.innerFormGroup.get("vaccinations") as FormArray;
  }

  set value(value: any) {
    if (value.vaccinations) {
      const vaccineCount = value.vaccinations.length;
      let vaccineControlsCount = this.vaccinations.controls.length;
      while (vaccineControlsCount !== vaccineCount) {
        value.vaccinations[vaccineControlsCount].vaccinationType =
          this.vaccine.indexOf(
            value.vaccinations[vaccineControlsCount].vaccinationType
          );
        this.addVaccination(event);
        vaccineControlsCount = this.vaccinations.controls.length;
      }
    }

    this.innerFormGroup.patchValue(value);
    this.onChange(value);
    this.onTouched();
  }

  constructor(
    protected formBuilder: FormBuilder,
    protected resourceManagementService: ResourceManagementService
  ) {
    super(formBuilder);

    this.innerFormGroup = this.formBuilder.group({
      vaccinations: new FormArray([]),
    });

    //Patch Select Value from RM Service
    this.resourceManagementService
      .getLookUpValues()
      .pipe()
      .take(1)
      .subscribe(
        (response) => {
          this.allVaccinationOptions = response["VaccineType"].map((item) => {
            return {
              display: item.description,
              value: item.id,
            };
          });
          this.vaccinationOptions = this.allVaccinationOptions;
        },
        (err) => {}
      );

    this.subscriptions.push(
      this.innerFormGroup.valueChanges.subscribe((value) => {
        let selectedVaccine = [];
        for (let i = 0; i < this.vaccinations.value.length; i++) {
          selectedVaccine.push(
            this.vaccinations.at(i).get("vaccinationType").value
          );
        }
        this.vaccinationOptions = this.allVaccinationOptions.filter(
          (item) => !selectedVaccine.includes(item.value)
        );
        this.onChange(value);
        this.onTouched();
      })
    );

    let now = new Date();
    const today = {
      year: now.getFullYear(),
      month: now.getMonth() + 1,
      day: now.getDate(),
    };
    const fifteenYearsLater = {
      year: now.getFullYear() + 15,
      month: now.getMonth() + 1,
      day: now.getDate(),
    };
    const thirtyYearsAgo = {
      year: now.getFullYear() - 30,
      month: now.getMonth() + 1,
      day: now.getDate(),
    };

    this.givenMin = thirtyYearsAgo;
    this.givenMax = today;
    this.readMin = thirtyYearsAgo;
    this.readMax = fifteenYearsLater;
    this.nextRequiredMin = today;
    this.nextRequiredMax = fifteenYearsLater;
  }

  validate(_: FormControl) {
    return this.innerFormGroup.valid
      ? null
      : { vaccinations: { valid: false } };
  }

  addVaccination(event) {
    event.preventDefault();
    const group = this.formBuilder.group({
      vaccinationType: [null, Validators.required],
      dateGiven: ["", Validators.required],
      dateRead: [""],
      dateNextRequired: [""],
    });

    this.vaccinations.push(group);
  }

  removeVaccination(event, index) {
    event.preventDefault();
    this.vaccinations.removeAt(index);
  }
}



// WEBPACK FOOTER //
// ./src/pages/company-resources/contact-details/employee-health/employee-health-contact-details.ts